import { NgModule } from '@angular/core';
import { BookingServiceModule } from 'libraries/service/booking/bookingService.module';
import { ConfigurationResourceModule } from 'libraries/service/resources/configuration/configurationResource.module';
import { PriceMapperModule } from './mappers/price-mapper.module';
import { TravellersMapperModule } from './mappers/travellers-mapper.module';
import { BookingPriceCardService } from './booking-price-card.service';

@NgModule({
    imports: [
        TravellersMapperModule,
        ConfigurationResourceModule,
        PriceMapperModule,
        BookingServiceModule,
    ],
    providers: [
        BookingPriceCardService,
    ],
})
export class BookingPriceCardServiceModule {}
